import styled from 'styled-components'
import { Spin as sp } from 'antd'

export const SpinnerWrapper = styled.div`
  display: ${(props) => props.display};
  flex-direction: ${(props) => props.direction};
  width: 100%;
  height: ${(props) => props.height};
`

export const SpinnerText = styled(sp)`
  padding-left: ${(props) => props.left};
  padding-bottom: ${(props) => props.bottom};
  padding-top: ${(props) => props.top};
  padding-right: ${(props) => props.right};
  text-align: center;
  background: transparent;
  border-radius: 4px;
`
